export const cardTicketStates = {
  usable: { value: 1, name: '已生效' },
  waited: { value: 2, name: '待生效' },
  invalid: { value: 3, name: '已失效' },
};

export function findCardTicketState(value) {
  for (const key in cardTicketStates) {
    if (value === cardTicketStates[key].value) return [cardTicketStates[key]];
  }
  return [];
}

/**
 * 根据课次券枚举过滤出合法的状态值，返回干净的数字数组
 * @param {string|Array|*} rawValue
 * @returns {number[]}
 */
export function getValidCardTicketStates(rawValue) {
  if (!rawValue) return [];

  const arr = Array.isArray(rawValue)
    ? rawValue
    : String(rawValue).split(',');

  const validValues = Object.values(cardTicketStates).map(s => s.value);

  return arr
    .map(v => +v)
    .filter(v => validValues.includes(v));
}
